export const SET_OBJECT = 'CANVAS/STRUCTURE/SET_OBJECT';
export const DONE_UPDATE = 'CANVAS/STRUCTURE/DONE_UPDATE';
export const TRIGGER_UPDATE = 'CANVAS/STRUCTURE/TRIGGER_UPDATE';
export const SET_UNSUBSCRIBE_HANDLER = 'CANVAS/STRUCTURE/SET_UNSUBSCRIBE_HANDLER';
export const RESET = 'CANVAS/STRUCTURE/RESET';